export default (templateData) => ({
  registrationNumber: templateData?.registrationNumber,
  country: templateData?.country,
  city: templateData?.city,
  postCode: templateData?.postCode,
  state: templateData?.state,
  address: templateData?.address
});
